module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "orders-product mt-3"
  }, [_c('div', {
    staticClass: "title-products font-size mb-1",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(_vm._s(_vm.orderState) + " - NRO DE ORDEN " + _vm._s(_vm.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between wrap"
  }, [_c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Precio Total: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v("PEN " + _vm._s(_vm.orderTotal))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Fecha de la Orden: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Estado: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderPaymentStateName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom"
  }, [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Direccion de envío : "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderWarehouseAddress))])])])]), _vm._v(" "), _c('div', {
    staticClass: "voucher-section"
  }, [_c('p', {
    staticClass: "title-deposit-data",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("DATOS DE DEPOSITO")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('div', {
    staticClass: "wrapper-list-item"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.deposit
    }
  }, [_c('el-form-item', {
    staticClass: "mb-2"
  }, [_c('el-input', {
    staticClass: "qtc-input",
    attrs: {
      "placeholder": "Nro de Deposito"
    },
    model: {
      value: (_vm.deposit.number),
      callback: function($$v) {
        _vm.$set(_vm.deposit, "number", $$v)
      },
      expression: "deposit.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-2"
  }, [_c('el-input', {
    staticClass: "qtc-input",
    attrs: {
      "placeholder": "Foto de Voucher"
    },
    model: {
      value: (_vm.deposit.voucher),
      callback: function($$v) {
        _vm.$set(_vm.deposit, "voucher", $$v)
      },
      expression: "deposit.voucher"
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    ref: "upLoadAvatar",
    attrs: {
      "hidden": "",
      "type": "file",
      "accept": _vm.allowedFiles
    },
    on: {
      "change": _vm.upLoadAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mask d-flex align-center justify-center",
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": _vm.maskFn
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loadAvatarBtn,
      "alt": "",
      "width": "22",
      "height": "20"
    }
  })])])], 1)], 1)], 1), _vm._v(" "), (_vm.deposit.voucher) ? _c('img', {
    staticClass: "voucher-image",
    attrs: {
      "src": _vm.deposit.voucher,
      "alt": "contanciar de pago"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-95 d-flex align-center justify-center"
  }, [_c('button', {
    staticClass: "btn-deposit",
    style: (("background-color:" + (_vm.globalColors.secondary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goTo('orders')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn-deposit",
    style: (("background-color:" + (_vm.globalColors.primary))),
    attrs: {
      "disabled": !(_vm.deposit.voucher && _vm.deposit.number),
      "type": "button"
    },
    on: {
      "click": _vm.updateVoucher
    }
  }, [_vm._v("Guardar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a63dae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/orders/deposit-data.vue
// module id = 1069
// module chunks = 15